import {View} from "vritra";


export default function ProduceList(props){
    const producelist=View({...props,tag:"ul"});

    producelist.innateHTML=`
        ${produce.map(item=>`
            <li>${item}</li>
        `)}
    `;

    return producelist;
}

const produce=[
    "pear",
    "potato",
    "pineapple",
    "cabbage",
    "raspberry",
    "peas",
];
